<template>
  <div
    id="map-controls"
    :class="{ 'weather-menu': showWeatherMenu || showContour }"
  >
    <div class="gkmg-container">
      <div v-if="getAddonFlag('GKMG_BASE_STATION')">
        <vx-tooltip text="資機材運搬管理" position="left">
          <button
            class="map-control-button cursor-pointer"
            @click="SET_ACTIVE_VESSEL_EQUIPMENT_BASE_STATION_SIDEBAR(true)"
          >
            <img :src="equipmentBaseStationIcon" />
          </button>
        </vx-tooltip>
      </div>
      <div v-if="getAddonFlag('GKMG_ANCHOR_MANAGEMENT')">
        <vx-tooltip text="アンカー位置管理" position="left">
          <button
            class="map-control-button cursor-pointer"
            @click="SET_ACTIVE_ANCHOR_VESSEL_SIDEBAR(true)"
          >
            <img :src="anchorIcon" />
          </button>
        </vx-tooltip>
      </div>
    </div>
    <vue-perfect-scrollbar class="flex flex-col" :settings="settings">
      <vx-tooltip text="地図の種類" position="left">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_LAYERS_SIDEBAR(true)"
        >
          <img :src="layersIcon" />
        </button>
      </vx-tooltip>
      <vx-tooltip text="検索" position="left" class="relative">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_SEARCH_SIDEBAR(true)"
        >
          <img :src="searchIcon" />
        </button>
        <img
          v-if="isFreeAccount"
          :src="lockedForFreeAccountIcon"
          class="locked-for-free-account-icon"
        />
      </vx-tooltip>
      <vx-tooltip text="自社船" position="left" class="relative">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_OWN_VESSEL_SIDEBAR(true)"
        >
          <img :src="ownVesselIcon" />
        </button>
        <img
          v-if="isFreeAccount"
          :src="lockedForFreeAccountIcon"
          class="locked-for-free-account-icon"
        />
      </vx-tooltip>
      <vx-tooltip text="選択船" position="left" class="relative">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_SELECT_VESSEL_SIDEBAR(true)"
        >
          <img :src="selectVesselIcon" />
        </button>
        <img
          v-if="isFreeAccount"
          :src="lockedForFreeAccountIcon"
          class="locked-for-free-account-icon"
        />
      </vx-tooltip>
      <vx-tooltip text="車両" position="left" class="relative">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_VEHICLE_SIDEBAR(true)"
        >
          <img :src="vehicleIcon" />
        </button>
        <img
          v-if="isFreeAccount"
          :src="lockedForFreeAccountIcon"
          class="locked-for-free-account-icon"
        />
      </vx-tooltip>
      <vx-tooltip text="表示フィルター" position="left">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_FILTER_SIDEBAR(true)"
        >
          <img :src="filterIcon" />
        </button>
      </vx-tooltip>
      <vx-tooltip text="プロット" position="left" class="relative">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_PLOT_SIDEBAR(true)"
        >
          <img :src="plotIcon" />
        </button>
        <img
          v-if="isFreeAccount"
          :src="lockedForFreeAccountIcon"
          class="locked-for-free-account-icon"
        />
      </vx-tooltip>
      <div v-if="getAddonFlag('GKMG_PRIVATE_PLOT')">
        <vx-tooltip
          text="プライベートプロット"
          position="left"
          class="relative"
        >
          <button
            class="map-control-button cursor-pointer"
            @click="SET_ACTIVE_PRIVATE_PLOT_SIDEBAR(true)"
          >
            <img class="private-plot-icon" :src="privatePlotIcon" />
          </button>
          <img
            v-if="isFreeAccount"
            :src="lockedForFreeAccountIcon"
            class="locked-for-free-account-icon"
          />
        </vx-tooltip>
      </div>
      <div v-if="getAddonFlag('GKMG_WEATHER_FORECAST')">
        <vx-tooltip text="気象海象" position="left" class="relative">
          <button
            class="map-control-button cursor-pointer"
            @click="SET_ACTIVE_WEATHER_SIDEBAR(true)"
          >
            <img :src="weatherIcon" />
          </button>
        </vx-tooltip>
      </div>
      <vx-tooltip text="設定" position="left" class="relative">
        <button
          class="map-control-button cursor-pointer"
          @click="SET_ACTIVE_SETTINGS_SIDEBAR(true)"
        >
          <img :src="settingIcon" />
        </button>
        <img
          v-if="isFreeAccount"
          :src="lockedForFreeAccountIcon"
          class="locked-for-free-account-icon"
        />
      </vx-tooltip>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Store
const { mapMutations: mapMutationsOfLiveMap } =
  createNamespacedHelpers("liveMap");

export default {
  props: {
    map: Object,
    showWeatherMenu: Boolean,
    showContour: Boolean,
  },
  data() {
    return {
      menuBtnStyle: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.1,
      },
      lockedForFreeAccountIcon: require("@/assets/images/icons/sideber-menu/locked.svg"),
    };
  },
  watch: {
    layoutType(val) {
      if (val === "horizontal") {
        this.themeMode === "semi-dark" ? (this.themeMode = "light") : null;
        this.navbarType === "hidden"
          ? (this.navbarTypeLocal = "floating")
          : null;
        this.$emit("updateNavbarColor", "#fff");
      }
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    ...mapGetters(["getAddonFlag"]),
    equipmentBaseStationIcon() {
      return require("@/assets/images/icons/sideber-menu/equipment_base_station.svg");
    },
    anchorIcon() {
      return require("@/assets/images/icons/sideber-menu/anchor.svg");
    },
    layersIcon() {
      return require("@/assets/images/icons/sideber-menu/layers.svg");
    },
    searchIcon() {
      return require("@/assets/images/icons/sideber-menu/search.svg");
    },
    ownVesselIcon() {
      return require("@/assets/images/icons/sideber-menu/vessel_own.svg");
    },
    selectVesselIcon() {
      return require("@/assets/images/icons/sideber-menu/vessel_select.svg");
    },
    vehicleIcon() {
      return require("@/assets/images/icons/sideber-menu/vehicle.svg");
    },
    filterIcon() {
      return require("@/assets/images/icons/sideber-menu/filter.svg");
    },
    plotIcon() {
      return require("@/assets/images/icons/sideber-menu/plot.svg");
    },
    privatePlotIcon() {
      return require("@/assets/images/icons/sideber-menu/private_plot.svg");
    },
    weatherIcon() {
      return require("@/assets/images/icons/sideber-menu/weather.svg");
    },
    settingIcon() {
      return require("@/assets/images/icons/sideber-menu/setteing.svg");
    },
    imageSatellite() {
      return require("@/assets/images/pages/map/sattellite.png");
    },
    isFreeAccount() {
      return this.$store.state.isFree === true;
    },
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_LAYERS_SIDEBAR",
      "SET_ACTIVE_SEARCH_SIDEBAR",
      "SET_ACTIVE_OWN_VESSEL_SIDEBAR",
      "SET_ACTIVE_SELECT_VESSEL_SIDEBAR",
      "SET_ACTIVE_FILTER_SIDEBAR",
      "SET_ACTIVE_PLOT_SIDEBAR",
      "SET_ACTIVE_PRIVATE_PLOT_SIDEBAR",
      "SET_ACTIVE_WEATHER_SIDEBAR",
      "SET_ACTIVE_VEHICLE_SIDEBAR",
      "SET_ACTIVE_VESSEL_EQUIPMENT_BASE_STATION_SIDEBAR",
      "SET_ACTIVE_SETTINGS_SIDEBAR",
      "SET_ACTIVE_ANCHOR_VESSEL_SIDEBAR",
    ]),
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#map-controls {
  display: flex;
  flex-direction: column;
  max-height: calc(var(--vh, 1vh) * 100 - 120px);

  @media screen and (max-height: $min-width-iphone-8) and (max-width: $max-width-iphone-11-pro) {
    max-height: 240px;
  }

  .map-control-button {
    margin: 3px;
    width: 50px;
    height: 50px;
    font-size: 20px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2d9cdb;
    border-radius: 5px;
    border: none;
    outline: none;

    .private-plot-icon {
      width: 28px;
      height: 28px;
    }
  }

  .gkmg-container {
    margin-bottom: 18px;

    .map-control-button {
      margin-top: 6px;
      background-color: #07a49a;
    }
  }

  .map-style-changer-button {
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
  }

  &.weather-menu {
    @media screen and (max-height: $max-width-iphone-11-pro) and (max-width: $min-width-iphone-11-pro) {
      max-height: 240px;
    }
  }

  .locked-for-free-account-icon {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 50px;
    height: 50px;
    z-index: 9;
    border-radius: 5px;
    background-color: rgba($aisea-slightly-gray, 0.4);
  }
  .ps__scrollbar-y-rail {
    pointer-events: none;
  }
}
</style>
